import type { Modifier } from '@atlaskit/popper';
import { HEADER_HEIGHT } from '../../constants.tsx';
import type { Column } from '../../types.tsx';
import { calculateStickyColumnsWidth } from '../calculate-sticky-columns-width/index.tsx';

export const getInlineEditModifier = ({
	scrollElement,
	columns,
	isStickyColumnsVisible,
	isScrolling,
}: {
	scrollElement: HTMLElement | null;
	columns: Column[];
	isStickyColumnsVisible: boolean;
	isScrolling: boolean;
}): (() => Modifier<'closeOnThreshold', object>[]) => {
	const totalWidth = isStickyColumnsVisible ? calculateStickyColumnsWidth(columns) : 0;

	return () => [
		{
			name: 'closeOnThreshold',
			enabled: true,
			phase: 'write',
			fn({ state }) {
				const scrollRect = scrollElement?.getBoundingClientRect();
				if (!scrollRect) {
					return;
				}
				const referenceElementRect = state.elements.reference.getBoundingClientRect();
				const isPartiallyHidden = referenceElementRect.left < scrollRect.left + totalWidth;

				if (
					scrollElement &&
					!isScrolling &&
					isPartiallyHidden &&
					state.elements.popper.style.display !== 'none'
				) {
					const scrollAmount = scrollRect.left + totalWidth - referenceElementRect.left + 8;

					scrollElement.scrollBy({
						left: -scrollAmount,
						behavior: 'auto',
					});
					return;
				}

				const shoudHide =
					referenceElementRect.left < scrollRect.left + totalWidth ||
					referenceElementRect.top < scrollRect.top + HEADER_HEIGHT ||
					referenceElementRect.bottom > scrollRect.bottom;
				if (shoudHide) {
					// eslint-disable-next-line no-param-reassign
					state.elements.popper.style.display = 'none';
				}
			},
		},
	];
};
